import { stepper } from '../../tokens/component';
import { effects, spacing } from '../../tokens/semantic';

const MuiStepIcon = {
    styleOverrides: {
        root: {
            color: stepper.color.button.bg.inactive,
            '&.Mui-active': {
                color: stepper.color.button.bg.active,
                outline: `${effects.border.lg} solid ${stepper.color.button.border.active}`,
                borderRadius: effects.radius.full,
            },
            '&.Mui-completed': {
                color: stepper.color.button.bg.completed,
            },
        },
    },
};

const MuiStepLabel = {
    styleOverrides: {
        iconContainer: ({ theme }) => ({
            fontSize: stepper.size.lg.fontSize,
            '&.Mui-active': {
                paddingRight: spacing.xs,
            },
            [theme.breakpoints.down('sm')]: {
                paddingRight: 0,
                fontSize: stepper.size.sm.fontSize,
            },
        }),
        label: ({ theme }) => ({
            fontSize: stepper.size.sm.fontSize,
            '&.Mui-active': {
                color: stepper.color.label.active,
                fontWeight: theme.typography.fontWeightRegular,
            },
            '&.Mui-completed': {
                color: stepper.color.label.completed,
                fontWeight: theme.typography.fontWeightRegular,
            },
            [theme.breakpoints.down('sm')]: {
                display: 'none',
                '&.Mui-active': {
                    display: 'block',
                    fontSize: stepper.size.sm.fontSize,
                },
            },
        }),
    },
};

const MuiStepConnector = {
    styleOverrides: {
        root: ({ theme }) => ({
            '&.Mui-active': {
                '& .MuiStepConnector-line': {
                    borderColor: stepper.color.connector.active,
                },
            },
            '&.Mui-completed': {
                '& .MuiStepConnector-line': {
                    borderColor: stepper.color.connector.completed,
                },
            },
            [theme.breakpoints.down('sm')]: {
                margin: `0 ${spacing.xxs} 0`,
            },
        }),
        line: {
            borderColor: stepper.color.connector.inactive,
        },
        lineHorizontal: {
            borderTopWidth: 3,
            borderRadius: effects.radius.sm,
        },
        lineVertical: {
            borderLeftWidth: 3,
        },
    },
};

const MuiStep = {
    styleOverrides: {
        root: ({ theme }) => ({
            [theme.breakpoints.down('sm')]: {
                padding: 0,
            },
            '&:first-of-type': {
                paddingLeft: 0,
            },
            '&:last-of-type': {
                paddingRight: 0,
            },
        }),
    },
};

const MuiStepper = {
    styleOverrides: {
        root: ({ theme }) => ({
            '& .MuiStepConnector-vertical': {
                marginLeft: spacing.md
            },
            [theme.breakpoints.down('sm')]: {
                '& .MuiStepConnector-vertical': {
                    marginLeft: spacing.sm
                },
                '&.CustomStepper--column': {
                    alignItems: 'flex-start',
                    '& .MuiStepLabel-root': {
                        flexDirection: 'column',
                        alignItems: 'center',
                    },
                    '& .MuiStepConnector-root': {
                        margin: `${spacing.sm} ${spacing.tiny} 0`,
                    },
                    '& .MuiStepLabel-label.Mui-active': {
                        marginTop: spacing.xxs,
                    },
                    '& .MuiStepLabel-iconContainer.Mui-active': {
                        paddingRight: 0,
                    },
                },
            },
        }),
    },
};

export { MuiStepIcon, MuiStepLabel, MuiStepConnector, MuiStep, MuiStepper };
export default { MuiStepIcon, MuiStepLabel, MuiStepConnector, MuiStep, MuiStepper };
